import { render } from "./SaveAttachment.vue?vue&type=template&id=06f78e86"
import script from "./SaveAttachment.vue?vue&type=script&lang=js"
export * from "./SaveAttachment.vue?vue&type=script&lang=js"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__